import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Button from 'carbon-react/lib/components/button';

import { QUERY_PARAMS, ROUTES, getForecastByIdOnboardingUrl } from '@futrli/shared-services';

import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPageTitle } from '../components/onboarding-page-title';
import { ForecastingNavigationTabs } from '../../detail/predictions/navigation/forecasting-navigation-tabs';
import { Invoices } from '../../detail/predictions/invoices/invoices';
import { LS_FORECASTING_ONBOARDING_STEP, SCENARIO_WITH_INVOICES_ONBOARDING_STEP } from '../const';
import { useOnboardingUrlInfo } from '../utils/hooks';

const InvoicesBillsIncludedTitle = () => {
  return (
    <OnboardingPageTitle
      title={
        <FormattedMessage
          id="onboarding.due_invoices_and_bills_included"
          defaultMessage="Due invoices and bills are included in your cash flow..."
        />
      }
      description={
        <FormattedMessage
          id="onboarding.overdue_invoices"
          defaultMessage="Overdue invoices and bills are always counted in the forecasted bank position for today."
        />
      }
    />
  );
};

const EditExcludeInvoicesBillsTitle = () => {
  return (
    <OnboardingPageTitle
      title={
        <FormattedMessage
          id="onboarding.edit_invoices_bills"
          defaultMessage="Edit when you’re going to pay them, or exclude them to help plan cash flow..."
        />
      }
      description={
        <FormattedMessage
          id="onboarding.bulk_update_option"
          defaultMessage="There is a bulk update option if you have a lot, that will be enabled after this guided flow."
        />
      }
    />
  );
};

export const InvoicesBillsIncluded = () => {
  const navigate = useNavigate();
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId, forecastId: tempForecastId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';
  const forecastId = tempForecastId || '';
  const { editInvoicesBills } = useOnboardingUrlInfo();

  const handleNextClick = () => {
    if (editInvoicesBills === 'true') {
      navigate(
        `${getForecastByIdOnboardingUrl(workspaceId, organisationId, forecastId, false, true)}/${
          SCENARIO_WITH_INVOICES_ONBOARDING_STEP.SELECT_TYPE
        }${ROUTES.SALES}${location.search}`
      );
    } else {
      const url = new URL(window.location.href);
      url.searchParams.set(QUERY_PARAMS.EDIT_INVOICES_BILLS, 'true');
      navigate(
        `${getForecastByIdOnboardingUrl(workspaceId, organisationId, forecastId, false, true)}/${
          SCENARIO_WITH_INVOICES_ONBOARDING_STEP.INVOICES_BILLS_INCLUDED
        }${url.search}`
      );
    }
    const newStep =
      editInvoicesBills === 'true'
        ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.SELECT_TYPE
        : SCENARIO_WITH_INVOICES_ONBOARDING_STEP.INVOICES_BILLS_INCLUDED;
    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, newStep);
  };

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      {editInvoicesBills === 'true' ? <EditExcludeInvoicesBillsTitle /> : <InvoicesBillsIncludedTitle />}

      <Button mb="30px" buttonType="primary" size="large" onClick={handleNextClick}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>
      <ForecastingNavigationTabs showOnlyInvoices />
      <Invoices />
    </div>
  );
};
